import React, { useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
} from "reactstrap";
import { FormattedMessage } from "react-intl";

export default function AddItemWithOnlyNameModal({ close, isOpen, onProceed }) {
  const [name, setName] = useState("");
  return (
    <Modal size="md" isOpen={isOpen} toggle={close}>
      <ModalHeader toggle={close}>
        <FormattedMessage id="Add" />
      </ModalHeader>
      <ModalBody>
        <Input onChange={(data) => setName(data.target.value)} />
      </ModalBody>
      <ModalFooter>
        <Button onClick={() => close()} outline color={"secondary"}>
          <FormattedMessage id="Cancel" />
        </Button>
        <Button onClick={() => onProceed(name)} outline color={"primary"}>
          <FormattedMessage id="Add" />
        </Button>
      </ModalFooter>
    </Modal>
  );
}
